export default {
    "APP User Management": [
        {
            title: "1.0 Uploading User Qualifications",
            vid_url: "https://youtube.com/embed/HqtMti0ow10"
        },
        {
            title: "1.1 Editing User Details",
            vid_url: "https://youtube.com/embed/OxRJqgkA-38"
        },
        {
            title: "1.2 Conducting Toolbox Talks",
            vid_url: "https://youtube.com/embed/4hX0fZ36cZE"
        }
    ],
    "APP Equipment Management": [
        {
            title: "2.0 Registering a Equipment Type and Piece of Equipment",
            vid_url: "https://youtube.com/embed/knDf4m01bJo"
        }
    ],
    "APP Machine Management": [
        {
            title: "3.0 Registering a New Machine",
            vid_url: "https://youtube.com/embed/3LIBIfjobxc"
        },
        {
            title: "3.1 Editing a Registered Machine",
            vid_url: "https://youtube.com/embed/4pfuoN6BBhw"
        },
        {
            title: "3.2 Creating a Vehicle Checklist",
            vid_url: "https://youtube.com/embed/1WQMc2Y-Lk8"
        },
        {
            title: "Creating a Custom Walkaround Inspection",
            vid_url: "https://youtube.com/embed/iMEzRMGi3Xo"
        }
    ],
    "APP Report Management": [
        {
            title: "4.0 Viewing & Sharing Reports",
            vid_url: "https://youtube.com/embed/Ird-sXKCWgM"
        },
        {
            title: "4.1 Creating a Daily Worksheet",
            vid_url: "https://youtube.com/embed/oaqzlt-en0Y"
        },
        {
            title: "4.2 Actioning a Jobpack Report",
            vid_url: "https://youtube.com/embed/nGmCP1vjyBg"
        },
        {
            title: "4.3 Creating a SSWP",
            vid_url: "https://youtube.com/embed/ipeCHETCSBI"
        },
        {
            title: "4.4 Managing Timesheets",
            vid_url: "https://youtube.com/embed/E8EJ0d0U7II"
        },
        {
            title: "4.5 Creating a new Jobpack",
            vid_url: "https://youtube.com/embed/MUP5PYJFy7A"
        },
        {
            title: "4.6 Generating a TM Plan",
            vid_url: "https://youtube.com/embed/TnhZLl4l4cM"
        },
        {
            title: "4.7 Sketching a TM Plan",
            vid_url: "https://youtube.com/embed/ivS8TJ5RTIc"
        }
    ],
    "APP General": [
        {
            title: "5.0 Using the Messenger Feature",
            vid_url: "https://youtube.com/embed/xhXC8tSxFVo"
        }
    ]
};
